import { render } from "./delivery-date-type-create-import.vue?vue&type=template&id=2b9f123a"
import script from "./delivery-date-type-create-import.vue?vue&type=script&lang=js"
export * from "./delivery-date-type-create-import.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__